/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * tabSelecter.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(recruit)/g;

/**
 * タブ - クリック
 */
const tabSelecterClick = () => {
  const tabTriggers = document.querySelectorAll(".js-tab-trigger");
  const tabTargets = document.querySelectorAll(".js-tab-target");

  for (let i = 0; i < tabTriggers.length; i++) {
    tabTriggers[i].addEventListener("click", (e) => {
      let currentMenu = e.currentTarget;
      let currentContent = document.getElementById(currentMenu.dataset.id);

      for (let i = 0; i < tabTriggers.length; i++) {
        tabTriggers[i].classList.remove("--active");
      }
      currentMenu.classList.add("--active");

      for (let i = 0; i < tabTargets.length; i++) {
        tabTargets[i].classList.remove("--show");
      }
      if (currentContent !== null) {
        currentContent.classList.add("--show");
      }
    });
  }
};

export {
  tabSelecterClick
};